export { default as VictoryAxis } from "./victory-axis";